"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.function.name");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const _theme_1 = require("@theme");
const _utils_1 = require("@utils"); // Component
var RadioBox = function RadioBox(_ref) {
    var name = _ref.name, options = _ref.options, selected = _ref.selected, onClick = _ref.onClick;
    return /*#__PURE__*/ react_1.default.createElement(Wrapper, null, options.map(function (option) {
        return /*#__PURE__*/ react_1.default.createElement(Option, {
            key: option,
            selected: option === selected
        }, /*#__PURE__*/ react_1.default.createElement("input", {
            type: "radio",
            name: name,
            value: option,
            checked: selected === option,
            onChange: function onChange() {
                return onClick(option);
            }
        }), /*#__PURE__*/ react_1.default.createElement("span", null, option));
    }));
}; // Styling
var Wrapper = styled_components_1.default.div.withConfig({
    displayName: "RadioBox__Wrapper",
    componentId: "sc-5rm194-0"
})(["display:flex;justify-content:center;align-items:stretch;height:32px;border:1px solid ", ";overflow:hidden;", "{height:40px;}"], _theme_1.palette.ink, _utils_1.mediaQuery('laptop'));
var Option = styled_components_1.default.label.withConfig({
    displayName: "RadioBox__Option",
    componentId: "sc-5rm194-1"
})(["flex:1 0 auto;display:flex;justify-content:center;align-items:center;transform:scale3d(1,1,1);background-color:", ";color:", ";", " text-align:center;cursor:pointer;transition:background-color 0.25s ease-in-out,transform 0.25s ease-in-out,color 0.25s ease-in-out;& input{display:none;}", "{&:hover{transform:scale3d(", ");}}"], function (props) {
    return !props.selected ? _theme_1.palette.snow : _theme_1.palette.ink;
}, function (props) {
    return props.selected ? _theme_1.palette.snow : _theme_1.palette.ink;
}, _theme_1.type.label, _utils_1.mediaQuery('tablet'), function (props) {
    return !props.selected ? '1.02,1.02,1' : '1,1,1';
}); // Typing
exports.default = RadioBox;
